import http, { addTokenAndKeyParams } from '@/utils/http'

export const getInviteAward = data => {
  return http({
    url: '/rest/award/total',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}
export const getAwardList = data => {
  return http({
    url: '/rest/award',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}
export const getInviteList = data => {
  return http({
    url: '/rest/invite/list',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}
export const getInviteQR = () => {
  return http({
    url: '/rest/invite',
    method: 'post',
    data: addTokenAndKeyParams()
  })
}
export const getInviteType = () => {
  return http({
    url: '/qxtx/h5/inviteFriend',
    method: 'post',
    data: addTokenAndKeyParams(),
    isFromQxtx: true
  })
}
export const wxShare = () => {
  return http({
    url: '/n/wx/shareConf?url=' + encodeURIComponent(document.location.href)
  })
}
